import React from "react";
import Grid from '@material-ui/core/Grid';
import Comma from "../../../assets/images/comma.png";


class shadow extends React.Component{
    constructor(props) {
        super(props);

    }
    componentDidMount() {
    }

    render() {
        return(
            <Grid className='button'  container alignItems={"center"} justify={"center"}
                  style={{width:'100%',borderColor:'transparent'}}>
                <Grid style={{height:'80%'}} className='button-line'/>
                <img src={Comma} className='button-comma'
                     style={{backgroundColor:'rgba(0.0.0.0.2)',height:'70%'}}
                     alt=""/>

            </Grid>
        )
    }
}
export default shadow